var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_3066",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29892",
    "data-name": "Group 29892",
    transform: "translate(-48.818 -153.818)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48.82, 153.82)",
    filter: "url(#Ellipse_3066)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3066-2",
    "data-name": "Ellipse 3066",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(15 9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29737",
    "data-name": "Group 29737",
    transform: "translate(71.305 167.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27778",
    "data-name": "Group 27778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30870",
    "data-name": "Path 30870",
    d: "M1260.761,229.561h0v-4.154a.969.969,0,0,0-.988-.949h-8.047a.969.969,0,0,0-.988.949v4.154h0c0,.014,0,.027,0,.04,0,2.2,2.244,3.986,5.012,3.986s5.013-1.784,5.013-3.986C1260.763,229.588,1260.761,229.575,1260.761,229.561Z",
    transform: "translate(-1250.738 -218.744)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27777",
    "data-name": "Group 27777",
    transform: "translate(1.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30871",
    "data-name": "Path 30871",
    d: "M1258.861,206.468a3.509,3.509,0,0,0-3.482,3.443c0,.63.007,1.13.013,1.611h1.318c-.007-.478-.013-.978-.013-1.611a2.166,2.166,0,1,1,4.332,0l0,1.611h1.318l0-1.611A3.509,3.509,0,0,0,1258.861,206.468Z",
    transform: "translate(-1255.378 -206.468)",
    fill: "#ffb063"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27779",
    "data-name": "Group 27779",
    transform: "translate(3.785 7.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_182",
    "data-name": "Union 182",
    d: "M.516,3.1V2.14A1.165,1.165,0,0,1,0,1.179,1.2,1.2,0,0,1,1.228,0,1.2,1.2,0,0,1,2.455,1.179a1.165,1.165,0,0,1-.516.962V3.1a.712.712,0,1,1-1.424,0Z",
    transform: "translate(0)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3a5384f772f148d3e20e68e51e552c6d.svg";
export { ForwardRef as ReactComponent };